import { Divida, OfertaNegociacao } from './../../shared/models/customer-debt-renegociation';
import { ActivatedRoute, Router } from '@angular/router';
import { RenegociacaoCartaoService } from 'src/app/renegociacao-cartao/renegociacao-cartao.service';
import { Component, OnInit } from '@angular/core';
import { AutenticacaoService } from 'src/app/seguranca/autenticacao.service';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { CurrencyMaskPipe } from 'src/app/shared/pipes/currency-mask.pipe';
import { RenegociacaoCartaoLoggerService } from '../renegociacao-cartao-logger.service';
import { AcaoRenegociacaoCartaoLoggerEnum, CondicaoPropostaEnum } from 'src/app/shared/models/renegociacao-cartao-logger-service.model';
import { ServicoCartaoIndisponivelError } from 'src/app/shared/models/servico-cartao-indisponivel.error';
import { ToastService } from 'src/app/shared/toast';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';

@Component({
  selector: "app-propostas-page",
  templateUrl: "./propostas-page.component.html",
  styleUrls: ["./propostas-page.component.scss"],
})
export class PropostasPageComponent implements OnInit {
  propostas: any[] = [];
  propostaSelecionada: any;
  numeroCartaoMascarado: string;
  debt: Divida;
  showPorpostas: boolean = false;

  constructor(
    private authService: AutenticacaoService,
    private renegociacaoCartaoService: RenegociacaoCartaoService,
    private router: Router,
    private loader: LoaderService,
    private currencyMask: CurrencyMaskPipe,
    private renegociacaoCartaoLoggerService: RenegociacaoCartaoLoggerService,
    private toast: ToastService,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) { }

  ngOnInit() {
    this.googleAnalyticsService.pushPageViewEvent({
      page_name: '/renegocie/portal/servicos/cartao/simular_proposta',
      page_template: 'renegocie'
    });
    this.handleOnInit();
  }

  async handleOnInit() {
    try {
      this.loader.start();
      this.debt = await this.renegociacaoCartaoService.debtAtual();
      this.numeroCartaoMascarado = this.mascararNumeroCartao(this.debt);
      this.buscarPropostas();
    } catch (error) {
      this.googleAnalyticsService.pushActionEvent({
        event: 'view_error',
        detail: error?.error?.message ?? 'Erro ao buscar dados da proposta',
      });

      if (error instanceof ServicoCartaoIndisponivelError) {
        this.toast.show({ type: 'error', title: 'Serviço temporariamente indisponível.', text: 'Por favor, tente novamente mais tarde.' })
      } else {
        this.toast.show({ type: 'error', title: 'Erro ao buscar dados da proposta.', text: 'Tente novamente mais tarde.' });
      }
    } finally {
      this.loader.stop();
    }
  }

  mascararNumeroCartao(debt: Divida) {
    return debt.idCartao.replace(/^0+/, "").replace(
      /^(\d{4})\d{8}(\d{4})$/,
      "$1.xxxx.xxxx.$2"
    );
  }

  get username() {
    return this.authService.autenticacao?.nomeCliente ?? "";
  }

  get customerData() {
    return this.renegociacaoCartaoService.dadosRenegociacaoCartao?.contato;
  }

  buscarPropostas() {
    this.debt.ofertasNegociacao.forEach((offer) => {
      this.propostas.push({
        id: offer.idOferta,
        text:
          offer.plano === 1
            ? "À vista: " + this.currencyMask.transform(offer.valorEntrada)
            : this.currencyMask.transform(offer.valorEntrada) +
            " + " +
            (offer.plano - 1) +
            "x " +
            this.currencyMask.transform(offer.valorParcela),
        offer: offer,
      });
    });
  }

  exibirProposta() {
    this.showPorpostas = true;

    this.googleAnalyticsService.pushActionEvent({
      event: 'click',
      detail: `simular proposta: ${this.formatarPropostaSelecionada()}`,
      context: 'portal reneg:em atraso'
    });
  }

  formatarPropostaSelecionada(): string {
    const offer = this.propostaSelecionada?.offer;
    if (!offer) { 
      return '';
    };
    return offer.plano === 1
      ? "À vista: " + this.currencyMask.transform(offer.valorEntrada)
      : this.currencyMask.transform(offer.valorEntrada) +
        " + " +
        (offer.plano - 1) +
        "x " +
        this.currencyMask.transform(offer.valorParcela);
  }

  contratarProposta(proposta: OfertaNegociacao) {
    this.renegociacaoCartaoService.ofertaAtualEscolhida = proposta;
    this.renegociacaoCartaoService.salvarOfertaEscolhidaId(proposta.idOferta);
    this.router.navigate([
      "/portal/renegociacao/cartao/lista-cartoes/aceitar-termos",
    ]);

    this.googleAnalyticsService.pushActionEvent({
      event: 'click',
      detail: `contratar acordo`,
      context: 'portal reneg:em atraso'
    })

    this.enviarLogPropostaEscolhida();
  }

  cancelarProposta() {
    this.googleAnalyticsService.pushActionEvent({
      event: 'click',
      detail: 'cancelar',
      context: 'portal reneg:em atraso'
    });
    this.router.navigate(["/portal/renegociacao/cartao/lista-cartoes"]);
  }

  enviarLogPropostaEscolhida() {
    this.renegociacaoCartaoLoggerService.enviarLogRenegociacaoCartao({
      actionLogger: AcaoRenegociacaoCartaoLoggerEnum.CARTAO_BRADESCO_ESCOLHER_PROPOSTA_ACTION,
      cartao: this.debt.idCartao,
      dividaId: this.debt.idDividaBradesco,
      dadoPropostaEscolhida: {
        condicao: this.propostaSelecionada.offer.plano > 1 ? CondicaoPropostaEnum.PARCELADO : CondicaoPropostaEnum.AVISTA,
        dataEntrada: this.debt.dataNegociacao,
        quantidadeParcelas: this.propostaSelecionada.offer.plano - 1,
        valorEntrada: this.propostaSelecionada.offer.valorEntrada,
        valorParcelas: this.propostaSelecionada.offer.valorParcela,
        valorTotalPlano: this.propostaSelecionada.offer.valorAcordo,
      }
    });
  }
}
